
  import { defineComponent } from 'vue';
  import { storeToRefs } from 'pinia';
  import GrouperTitle from 'components/grouper-common/GrouperTitle.vue';
  import GrouperBanner from 'components/grouper-common/GrouperBanner.vue';
  import GrouperFooter from 'components/grouper-common/GrouperFooter.vue';
  import GrouperBody from 'components/grouper-common/GrouperBody.vue';
  import LoadingBar from 'src/components/grouper-common/LoadingBar.vue';
  import LoadingError from 'src/components/grouper-common/LoadingError.vue';
  import { useGrouperStore } from 'src/stores/grouper-store';


  export default defineComponent({
    name: 'MainLayout',
    components: {
      GrouperTitle,
      GrouperBanner,
      GrouperFooter,
      GrouperBody,
      LoadingBar,
      LoadingError,
    },
    setup: () => {
      const { loaded, loadingTimeout, readOnly } = storeToRefs(useGrouperStore())
      return {
        loaded,
        loadingTimeout,
        readOnly,
      }
    }
  });
